export const variableNormalizer = (variable) => {
  if (typeof variable === "string") {
      return '"' + variable + '"';
  } else if (typeof variable === "undefined") {
      return null
  } else {
      return variable
  }
}
